var _defs, _g, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-stripes"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10582",
    "data-name": "Rectangle 10582",
    width: 136,
    height: 136,
    transform: "translate(56 1550)",
    fill: "#292b44"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_Stripes",
    "data-name": "Mask Group 45",
    transform: "translate(-56 -1550)",
    "clip-path-stripes": "url(#clip-path-stripes)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stripes",
    transform: "translate(47 1534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_Pink",
    "data-name": "Path Pink",
    d: "M153.129,184.287-16.08,15.078-27.731,26.729,141.478,195.938Z",
    fill: "#da3db0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_Yellow",
    "data-name": "Path Yellow",
    d: "M146.108,200.151-26.35,27.693-38,39.344,134.457,211.8Z",
    fill: "#f4ac3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_Light_Blue",
    "data-name": "Path Light_Blue",
    d: "M167.9,176.979-16.08-7-27.731,4.651,156.248,188.63Z",
    fill: "#7efbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.5 175.5L-8.5 0L-38 39L98 175.5H169.5Z",
    fill: "url(#paint0_linear_1855_2695)"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1855_2695",
    x1: 29.5001,
    y1: -60.5,
    x2: 66.0001,
    y2: 87.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripes);
export default __webpack_public_path__ + "static/media/stripes.d447976257676a59a18f6d03626563ef.svg";
export { ForwardRef as ReactComponent };